import { GetterTree } from "vuex";
import { SearchState, RootState } from "@/types/search";

const getters: GetterTree<SearchState, RootState> = {
  getRecommendRecipes: (state: SearchState) => {
    return state.recommendRecipes;
  },
  getRankingRecipes: (state: SearchState) => {
    return state.rankingRecipes;
  },
  getSearchKeywordRecipes: (state: SearchState) => {
    return state.searchKeywordRecipes;
  },
  getTagGroups: (state: SearchState) => {
    return state.tagGroups;
  },
  getKeyword: (state: SearchState) => {
    return state.keyword;
  },
  getSortType: (state: SearchState) => {
    return state.sortType;
  },
  getTags: (state: SearchState) => {
    return state.tags;
  },
  getProducts: (state: SearchState) => {
    return state.products;
  },
  getApplianceList: (state: SearchState) => {
    return state.applianceList;
  }
};

export default getters;
